import { createSlice } from "@reduxjs/toolkit";

const CardSlice = createSlice({
  name: "cards",
  initialState: {
    cardExisted:"1" ,
  },
  reducers: {
    changeCardTrue: (state, action) => {
      state.cardExisted=action.payload; // Add document ID
    },
    changeCardFalse: (state) => {
      state.cardExisted = "1"; // Reset state to an empty array
    },
  },
});

export const { changeCardTrue, changeCardFalse } = CardSlice.actions;

export default CardSlice.reducer;
